import { render, staticRenderFns } from "./home_page2.vue?vue&type=template&id=e99dad90&scoped=true&"
import script from "./home_page2.vue?vue&type=script&lang=js&"
export * from "./home_page2.vue?vue&type=script&lang=js&"
import style0 from "./home_page2.vue?vue&type=style&index=0&id=e99dad90&prod&lang=less&"
import style1 from "./home_page2.vue?vue&type=style&index=1&id=e99dad90&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "e99dad90",
  null
  
)

export default component.exports